import { makeModelTables } from '../utils'
import { formatScientific } from '@/utils/formatters'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { getPredictionDataBySource } from '@/components/combined-predict/models/epiSuite/utils'

const modelSummaryMapper = (item, meta) => {
  const rows = (meta?.children ?? []).map((child) => {
    const node = getPredictionDataBySource(item, child.id)
    const name = node?.name
    const value = node?.value
    return [name, formatScientific(value, { precision: 4, blank: '-' })]
  })

  return {
    tables: [
      {
        headers: [
          '',
          'Value',
          //TODO: 'Explanation'
        ],
        rows: rows,
      },
    ],
  }
}

const modelDescriptorsMapper = (item) => ({
  tables: makeModelTables(item?.models),
})

const biowin = (items) => {
  const item = items?.find((item) => item?.property === 'biodegradationRate')
  const meta = findEpiSuiteGroupById('biodegradationRate')

  return {
    title: meta?.shortTitle ?? meta?.name,
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: modelSummaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item, meta),
    modelOutput: item?.output,
  }
}

export { biowin }
